module.exports = __webpack_public_path__ + "static/media/new_button.97a02851.svg";